import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, Route,CanLoad } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '@vex/http-service/auth.service';
import { LayoutService } from '@vex/services/layout.service';
import { ConfigService } from '@vex/services/config.service';
import { ThemeID } from '@vex/constants/settings';
import { BreadcrumbsService } from '@vex/constants/breadcrumbs';
import {Title} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild,CanLoad {
  themeId: string = ThemeID;
  stateUrl: string = '';
  constructor(
    private authService: AuthService,
    private layoutService: LayoutService,
    public configService: ConfigService,
    private breadcrumbsService: BreadcrumbsService,
    private titleService: Title,
    private router: Router) {
    this.configService.config$.subscribe((t) => {
      this.themeId = t.id;
      this.displayHeader(this.stateUrl)
    })
  }

  canLoad(
    route: Route
  ): boolean | Observable<boolean> | Promise<boolean> {
    const data = route.data || {};
    let access = true;
    if (data['featureIds'] && data['featureIds'].length) {
      let status: boolean = false;
      for(let i = 0; i < data['featureIds'].length; i++) {
        let id = data['featureIds'][i];
        access = this.authService.getRights('FeatureIds', id);
        if(access) {
          status = true;
          break;
        }
      }
      return status;
    }
    return true;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const url: string = state.url;
    this.stateUrl = url;
    
    let data = route.data;

    let queryParams = route.queryParams;
    let basePathToUse = data.basePath;

    if(url.startsWith('/compliance/check')){
      if (queryParams['isDeviceInventory'] === 'true') {
          basePathToUse = data.basePathDevice;
      } else if (queryParams['isDynamicTemplate'] === 'true') {
          basePathToUse = data.basePathTemplate;
      } else if (queryParams['isInventoryJob'] === 'true') {
          basePathToUse = data.basePathInventoryJob;
      } else if (queryParams['isInventoryCloud'] === 'true') {
          basePathToUse = data.basePathInventoryCloud;
      } else if (queryParams['isConnectivity'] === 'true') {
          basePathToUse = data.basePathConnectivity;
      }
    }

    let access = true;
    let title: string = 'Kumorai - Multi-Cloud Automation, Orchestration, Compliance & Governance';
    if(data.id != undefined) {
      access = this.authService.getRights(data.type, data.id);
    }
    if(data.id != undefined) {
      this.getTitle(basePathToUse);
    } else {
      if(basePathToUse == 'dashboard') {
        this.titleService.setTitle('Dashboard');
      }
    }

    if(!access){
      this.layoutService.showHeader = true;
      this.layoutService.showSettingIcon = false;
      this.router.navigate(['/unauthorized']);
      return false;
    }
    this.displayHeader(url);
    this.displaySettingIcon(url);
    
    return (this.checkLogin(url) && access);
  }

  async getTitle(basePath) {
    let title = 'Kumorai - Multi-Cloud Automation, Orchestration, Compliance & Governance';
    let breadcrumbs: any = await this.breadcrumbsService.getBreadcrumbs(basePath);
    if(breadcrumbs?.Crumbs?.length > 0) {
      title = breadcrumbs.Crumbs?.join(' . ');
    }else{
      title = this.getDefaultTitle(basePath);
    }
    this.titleService.setTitle(title);
  }

  getDefaultTitle(basePath: string) {
    switch (basePath) {
      case 'platform-settings/worker-nodes':
        return 'Worker Nodes';
      case 'platform-settings/audit':
        return 'Audit';
      default:
        return 'Kumorai - Multi-Cloud Automation, Orchestration, Compliance & Governance';
    }
  }

  // || url.toLowerCase().includes('/deployment/deploy-blueprint/')
  displayHeader(url) {
    this.layoutService.showHeader = true;
    if ((url.toLowerCase().includes('/network-management/blueprintdesigner/create')
      || url.toLowerCase().includes('/network-management/blueprintdesigner/edit')
      || url.toLowerCase().includes('/network-management/delete-meta-management')
      || url.toLowerCase().includes('/platform-settings/create-template-wizard')
      || url.toLowerCase().includes('/deployment/deploy-blueprint/')
      || url.toLowerCase().includes('/deployment/deploy-code/')
      || url.toLowerCase().includes('/deployment/deploy-code-device/')
      || url.toLowerCase().includes('/application-settings/create-cloud')
      || url.toLowerCase().includes('/application-settings/create-integrations')
      || url.toLowerCase().includes('/application-settings/update-integrations')
      || url.toLowerCase().includes('/workflow/create-workflow-template')
      || url.toLowerCase().includes('/discovery/claim-vpc')
      || url.toLowerCase().includes('/discovery/bulk-vpcs')
      || url.toLowerCase().includes('/network-management/new-cloud-migration')
      || url.toLowerCase().includes('/network-management/update-cloud-migration')
      || url.toLowerCase().includes('deployment/change-request-inventory')
      || url.toLowerCase().includes('/application-settings/delete-cloud')
      || url.toLowerCase().includes('/security/create-application')
      || url.toLowerCase().includes('/security/change-process')
      || url.toLowerCase().includes('/compliance/update-benchmark')
      || url.toLowerCase().includes('/compliance/create-benchmark')
      || url.toLowerCase().includes('/compliance/update-policy')
      || url.toLowerCase().includes('/compliance/check')
      || url.toLowerCase().includes('/discovery/connectivity-discovery')
      || url.toLowerCase().includes('compliance/bulk-assessment')
      || url.toLowerCase().includes('/network-management/meta-management')
      || url.toLowerCase().includes('/device/visualization')
      || url.toLowerCase().includes('/location/tree')
      || url.toLowerCase().includes('/compliance/create-policy')
      || url.toLowerCase().includes('/location/create')
      || url.toLowerCase().includes('/device/create-device')
      || url.toLowerCase().includes('/device/rollback')
      || url.toLowerCase().includes('/network-management/create-intelligence-config')
      || url.toLowerCase().includes('/workflow/workflow-template-deploy-params')
      || url.toLowerCase().includes('/connectivity/create'))
      || url.toLowerCase().includes('/application-settings/clone-integrations')
      && this.themeId == ThemeID)
      this.layoutService.showHeader = false;
  }

  displaySettingIcon(url) {
    this.layoutService.showSettingIcon = false;
    if (url.toLowerCase().includes('/dashboard'))
      this.layoutService.showSettingIcon = true;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(childRoute, state);
  }

  checkLogin(url: string) {
    this.authService.redirectUrl = url;
    return this.authService.isLoggedIn();
  }
}
